import { render, staticRenderFns } from "./ProductLocaleForm.vue?vue&type=template&id=17047c4a&scoped=true"
import script from "./ProductLocaleForm.vue?vue&type=script&lang=js"
export * from "./ProductLocaleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17047c4a",
  null
  
)

export default component.exports